import { ReduxUtils, Consts } from '../../dependencies';

const { FETCH } = Consts.apiTypes;
const { EXPENSES } = Consts.entityKeys;

export const fetchExpensesApiSelector = (state, groupId) => ReduxUtils.apiSelector(state, EXPENSES, FETCH, groupId);
